import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Container, Grid, Image, GridColumn, Icon} from "semantic-ui-react";
import logo from "../assets/images/logo_gray.svg";

class Header extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
  };

  render() {
    const { show, season } = this.props;
	let footer;
    let CCPA_Link;
    const { REACT_APP_HIDE_COOKIE_POLICY, REACT_APP_SHOW_CALIFORNIA_NOTICE } = process.env;
    this.hideCookiePolicy = REACT_APP_HIDE_COOKIE_POLICY != "1" ? true : false;
    this.showCaliforniaPolicy = REACT_APP_SHOW_CALIFORNIA_NOTICE == "1" ? true : false;
    const privacyPolicy = process.env.REACT_APP_PRIVACY_POLICY_URL;

	if (process.env.REACT_APP_SHOW_HEADER_FOOTER == 1)
      {  
		  	footer = <Grid className="ui">
		                    <GridColumn className="footerLogo">
		                        <Image className="ui" src={logo} width="75" alt="" />
		                    </GridColumn>
		                </Grid>;
			  
		  }

    if (process.env.REACT_APP_HIDE_CCPA_LINK_FOR_TLR != 1) {
      CCPA_Link = <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer footerShowName">
        <div style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }}>
          <a href="javascript:cbsoptanon.ot.showPreferenceCenter()" className="ot-sdk-show-settings ui pageShowTitle" style={{ color: `#${season.hexColorCodeC}`, textAlign: "right", cursor: "pointer" }} >Your Privacy Choices</a>
        </div>
      </GridColumn>
    }

    return (
      <div>
        <Container className="ui footer social">
          <Container className="ui">
            <Grid className="ui grid middle aligned stackable">
              <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer footerShowName">
                <h3
                  className="ui pageShowTitle"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name}
                </h3>
                <span className="talkAboutIt">Talk about it </span>
                <Icon
                  className="right chevron"
                  style={{ color: `#${season.hexColorCodeC}` }}
                />
              </GridColumn>
              <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer socialIcons">
                <span className="socialCTA">Follow the show</span>
                {season.facebookUrlC && (
                  <a
                    href={season.facebookUrlC}
                    className="ui circular facebook icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="icon facebook f" />
                  </a>
                )}
                {season.googlePlusUrlC && (
                  <a
                    href={season.googlePlusUrlC}
                    className="ui circular google plus icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="icon google plus g" />
                  </a>
                )}
                {season.twitterUrlC && (
                  <a
                    href={season.twitterUrlC}
                    className="ui circular twitter icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="icon twitter" />
                  </a>
                )}
                {season.instagramUrlC && (
                  <a
                    href={season.instagramUrlC}
                    className="ui circular instagram icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="icon instagram" />
                  </a>
                )}
                {season.youtubeUrlC && (
                  <a
                    href={season.youtubeUrlC}
                    className="ui circular youtube icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="youtube icon" />
                  </a>
                )}
                {season.tumblrUrlC && (
                  <a
                    href={season.tumblrUrlC}
                    className="ui circular tumblr icon button"
                    role="button"
                  >
                    <i aria-hidden="true" className="tumblr icon" />
                  </a>
                )}
              </GridColumn>

              <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer footerShowName">

              </GridColumn>
              <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer footerShowName">
                <div style={{ color: `#${season.hexColorCodeC}`, textAlign: "right", fontSize: "18" }}>
                  <a className="ui pageShowTitle" style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }} href={privacyPolicy} target="_blank" rel="noopener noreferrer">
                    Privacy Policy 
                  </a>
                </div>
                {this.hideCookiePolicy && (
                  <div style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }}>
                    <a className="ui pageShowTitle" style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }} href="https://www.viacomcbsprivacy.com/cookies" target="_blank" rel="noopener noreferrer">
                      Cookie Policy
                    </a>
                  </div>
                )}

                {this.showCaliforniaPolicy && (
                  <div style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }}>
                    <a className="ui pageShowTitle" style={{ color: `#${season.hexColorCodeC}`, textAlign: "right" }} href="https://privacy.paramount.com/en/policy#additional-information-us-states" target="_blank" rel="noopener noreferrer">
                      California Notice
                    </a>
                  </div>
                )}
                
              </GridColumn>
              <GridColumn className="sixteen wide mobile eight wide tablet eight wide computer footerShowName">

              </GridColumn>
              {CCPA_Link}
            </Grid>
          </Container>
        </Container>

        <Container className="ui footer">
          <Container className="ui">
            <Grid className="ui stackable">
              <GridColumn className="ten wide terms">

              </GridColumn>

              <GridColumn className="six wide copywrite">
              </GridColumn>
            </Grid>
			{footer}
          </Container>
        </Container>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Footer.js